import { Drawer, DrawerContent } from '@/shared/components/ui/Drawer';
import { Button } from '@/shared/components/ui/Button';
import { X } from 'lucide-react';
import { PraiseReviewContent } from './PraiseReviewContent';
import { useLanguage } from '@/shared/contexts/LanguageContext';
import { useTranslation } from 'react-i18next';

interface PraiseReviewDrawerProps {
  isOpen: boolean;
  praiseId: string;
  onClose: () => void;
}

export const PraiseReviewDrawer = ({
  isOpen,
  praiseId,
  onClose,
}: PraiseReviewDrawerProps) => {
  const { isRTL } = useLanguage();
  const { t } = useTranslation('common');

  return (
    <Drawer
      open={isOpen}
      onOpenChange={(open) => !open && onClose()}
      direction={isRTL ? 'left' : 'right'}
    >
      <DrawerContent className="h-full w-full">
        <div className="sticky top-0 z-10 border-b bg-white px-6 py-4">
          <div className="flex items-center justify-between">
            <h2 className="text-lg font-semibold">{t('praiseReview')}</h2>
            <Button
              variant="ghost"
              size="sm"
              onClick={onClose}
              className="gap-2"
            >
              <X className="h-4 w-4" />
              {t('close')}
            </Button>
          </div>
        </div>

        <div className="h-[calc(100vh-5rem)] overflow-y-auto">
          <PraiseReviewContent praiseId={praiseId} />
        </div>
      </DrawerContent>
    </Drawer>
  );
};
